<div class="survey-snack-bar" cdkTrapFocus>
	<div class="header">
		<ng-content select="[title]"></ng-content>
	</div>
	<div [formGroup]="form" #content>
		<ng-content select="[description]"></ng-content>

		<div class="star-rating-container">
			<mat-radio-group formControlName="rating" class="star-rating" #firstFocusableElement>
				<mat-radio-button
					*ngFor="let star of [1, 2, 3, 4, 5]"
					[value]="star"
					(mouseover)="hoveredRating=star"
					(mouseleave)="hoveredRating=null"
					class="star"
					aria-describedby="feedback-description"
					[ngClass]="{'filled': hoveredRating ? star <= hoveredRating : star <= form.value.rating}">
						<i class="ficon-pointy-star"></i>
				</mat-radio-button>
			</mat-radio-group>
			<mat-error
				*ngIf="form.controls.rating.touched && form.controls.rating.hasError('required')"
				translate="customer-feedback-rating-required">
			</mat-error>
		</div>

		<mat-form-field appearance="outline" floatLabel="always">
			<mat-label translate="customer-feedback-more"></mat-label>
			<textarea matInput formControlName="feedback"></textarea>
		</mat-form-field>
	</div>
	<div class="action-wrapper">
		<ng-container *ngIf="hasProjectedContent; else defaultContent">
			<ng-content></ng-content>
		</ng-container>

		<ng-template #defaultContent>
			<button
				class="tertiary-btn no-thanks"
				(click)="close.emit()"
				translate="common_no-thanks">
			</button>
			<button
				class="tertiary-btn snooze"
				(click)="close.emit(true)"
				translate="common_snooze">
			</button>
		</ng-template>

		<button
			class="primary-btn submit-btn"
			[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
			(click)="submit.emit()"
			translate>
			common_submit
		</button>
	</div>
</div>
